function slider (params) {
  var obj = {
    el: params.el,
    w: params.w || 280, //canvas的宽度
    h: params.h || 150,  //canvas的高度
    range: params.range || 5, //相差多少像素内触发成功
    bigImageBase64: params.bigImageBase64 || [], //图片数组
    sliderW: params.sliderW, //slider的边长
    posY: params.posY || 0,// 滑块儿Y轴距离
    sliderIcon: params.sliderIcon || '',
    refreshIcon: params.refreshIcon || '',
    smallImageBase64: params.smallImageBase64,
    rateX: params.rateX,//当前图片与原始图片x轴比例
    siderId: params.siderId,//获取图片信息id
    isShowSlider: params.isShowSlider,
    refresh: params.refresh, //刷新回调
    finish: params.finish, //完成回调
    // sliderTextName: params.sliderTextName ? params.sliderTextName : '向右滑动填充拼图'
  };

  //创建canvas的父元素
  var container = document.querySelector(obj.el);
  container.innerHTML = '';
  var canvas_wrap = document.createElement('div');
  canvas_wrap.className = "canvas_wrap";
  canvas_wrap.style.cssText = "position:relative;overflow:hidden;border-radius:4px;width:" + obj.w + "px;height:" + obj.h + "px;background:#fff;"

  //创建大小canvas元素
  var bigCanvas = document.createElement('canvas');
  var smartCanvas = bigCanvas.cloneNode(true);
  bigCanvas.width = smartCanvas.width = obj.w;
  bigCanvas.height = smartCanvas.height = obj.h;
  bigCanvas.style.cssText = smartCanvas.style.cssText = "position:absolute;left:0;top:0;";

  var bcxt = bigCanvas.getContext('2d'), scxt = smartCanvas.getContext('2d'), img = new Image(), smallImageBase64 = new Image();

  //刷新按钮
  // var refreshDom = document.createElement('div');
  // refreshDom.className = "slider_refresh";
  // refreshDom.innerHTML = '刷新';
  // refreshDom.style.cssText = "position:absolute;bottom:10px;z-index:10;cursor: pointer;"

  //创建拖拽区域
  var slider_wrap = document.createElement('div'),
    // slider_text = document.createElement('span'),
    slider = document.createElement('div'),
    sliderCover = document.createElement('div');

  slider_wrap.className = "slider_wrap";
  slider.className = "canvas_slider";
  sliderCover.className = "sliderCover";

  // slider_text.innerText = obj.sliderTextName;

  slider_wrap.style.cssText = "width:" + obj.w + "px;height:15px; border-radius:30px;line-height:15px; position:relative;margin-top:25px;text-align:center;box-shadow: inset 0 0 4px #ccc;font-size: 14px;color:#999999;background-color:#E5E5E5";
  // slider_text.style.cssText = "position: relative;user-select: none;z-index:1;color:#9A9A9A"
  slider.style.cssText = "cursor: pointer;position: absolute;left: 0;top: 50%;z-index: 2;height: " + (obj.sliderW * 0.6) + "px;width: " + obj.sliderW + "px;background-image : url(" + obj.sliderIcon + ");background-size: 100% 100%;border-radius: " + obj.sliderW + "px;line-height:" + obj.sliderW + "px;text-align:center;transform: translateY(-50%);box-shadow:0 0 10px #ccc";
  sliderCover.style.cssText = "position: absolute;left: 0;top:0;width:0;height:100%;background:#eee;border-radius:30px;background-color:#1678FF;color:#fff"

  // slider_wrap.appendChild(slider_text);
  slider_wrap.appendChild(slider);
  slider_wrap.appendChild(sliderCover);
  canvas_wrap.appendChild(bigCanvas);
  canvas_wrap.appendChild(smartCanvas);
  // container.appendChild(refreshDom);
  container.appendChild(canvas_wrap);
  container.appendChild(slider_wrap);


  /*
  canvasCoverL:随机生成占位块canvas的x轴位置
  startDownX://鼠标按下时x轴位置
  smartCanvasBL: 可移动canvas的left初始值
  sliderMaxRange：slider可移动的最大距离
  */
  var canvasCoverL = 0, startDownX = 0, smartCanvasBL = 0, sliderMaxRange = obj.w - obj.sliderW;

  //生成canvas图案
  function creatCanvas () {
    //重置初始值
    canvasCoverL = 0; startDownX = 0; smartCanvasBL = 0;
    slider.style.left = sliderCover.style.width = 0;
    smartCanvas.style.left = 0
    smartCanvasBL = 0;
    //先清空画布
    bcxt.clearRect(0, 0, obj.w, obj.h)
    scxt.clearRect(0, 0, obj.w, obj.h)
    smartCanvas.width = obj.w;

    img.src = obj.bigImageBase64
    smallImageBase64.src = obj.smallImageBase64

    img.onload = function () { //一定要在onload里调用，否则canvas里不能放进图片
      bcxt.drawImage(img, 0, 0, obj.w, obj.h);
      scxt.drawImage(smallImageBase64, 0, obj.posY, obj.sliderW, obj.sliderW);
    }
    obj.refresh && obj.refresh();
  }

  //滑块被按下
  function moveStart (e) {
    var ev = e || window.event;
    //1.鼠标按下之前必须清除掉后面设置的过渡属性
    slider.style.transition = "";
    sliderCover.style.transition = '';
    // slider_text.innerHTML = '';
    startDownX = ev.touches != undefined ? ev.touches[0].clientX : ev.clientX;
    ev.touches != undefined ? document.ontouchmove = null : document.onmousemove = null;
  }
  //滑块移动
  function moveProcess (e) {
    var ev = e || window.event,
      downX = (ev.touches != undefined)
        ? ev.touches[0].clientX
        : (startDownX != 0 ? ev.clientX : 0), range = downX - startDownX;
    var sliderRange = range <= 0 ? 0 : (range < sliderMaxRange ? range : sliderMaxRange);
    slider.style.left = sliderRange + "px";
    sliderCover.style.width = obj.sliderW / 2 + sliderRange + "px";
    smartCanvas.style.left = smartCanvasBL + sliderRange + "px";
  }

  //停止滑动
  function moveEnd (e) {
    var ev = e || window.event;
    ev.touches != undefined ? document.ontouchmove = null : document.onmousemove = null;
    var smartCanvasL = parseInt(smartCanvas.style.left);
    getStatus(smartCanvasL, obj.siderId, obj.rateX, (bool) => {
      obj.finish && obj.finish({
        status: bool,
        sliderId: obj.siderId,
      });
      if (bool) {

      } else {
        var timer = null, step = 10;
        var sliderL = parseInt(slider.style.left)
        //回到初始位置动画
        timer = setInterval(function () {
          sliderL -= step;
          step += 5;
          if (sliderL <= 0) {
            clearInterval(timer);
            sliderL = 0;
            slider.style.left = sliderCover.style.width = 0;
            smartCanvas.style.left = smartCanvasBL + "px"
          } else {
            slider.style.left = sliderL + "px";
            sliderCover.style.width = sliderL + obj.sliderW / 2 + "px";
            smartCanvas.style.left = sliderL + smartCanvasBL + "px";
          }
        }, 20)
      }
    })
    //只要鼠标松开了，说明此时不需要拖动滑块了，那么就清除鼠标移动和松开事件。
    document.onmousemove = null;
    document.onmouseup = null;
    document.ontouchmove = null;
    document.ontouchend = null;
  }

  //事件调用
  creatCanvas();
  //刷新点击刷新按钮进行刷新
  // refreshDom.onclick = refreshDom.ontouchstart = creatCanvas;
  slider.ontouchstart = function () {
    console.log(22222);
    moveStart();
    document.ontouchmove = moveProcess;
    document.ontouchend = moveEnd;
  };
  slider.onmousedown = function () {
    moveStart();
    document.onmousemove = moveProcess;
    document.onmouseup = moveEnd;
  };

  // 解决有些时候,在鼠标松开的时候,元素仍然可以拖动;
  document.ondragstart = function (ev) {
    ev.preventDefault();
  };
  document.ondragend = function (ev) {
    ev.preventDefault();
  };

}

import { getCodeCheck } from '@/request/login.js'
import { Toast } from 'vant';

//滑动验证成功失败接口
function getStatus (value, siderId, rateX, callback) {
  let params = {
    id: siderId,
    x: parseInt(value / rateX)
  }
  getCodeCheck(params).then(res => {
    if (res.code == 0) {
      callback(true)
    } else {
      callback(false)
      Toast(res.msg)
    }
  })
}

export default {
  slider
}



// WEBPACK FOOTER //
// ./src/components/sliderVertify/js/slider.js